import script from "./OffscreenCompositeImage.vue?vue&type=script&setup=true&lang=js"
export * from "./OffscreenCompositeImage.vue?vue&type=script&setup=true&lang=js"

import "./OffscreenCompositeImage.vue?vue&type=style&index=0&id=40b6c264&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40b6c264"]])

export default __exports__